import { LuckySpinReward } from '@/models/user-reward/lucky-spin/lucky-spin-rewards';
import { Nullable } from '@starsoft/common/interfaces';
import {
  LuckySpinActions,
  LuckySpinBasePayload,
  SetIsPrizeDefinedPayload,
  SetIsSpinningPayload,
  SetPrizePayload,
} from './props';

export function setLuckySpinIsSpinning(
  isSpinning: boolean,
): SetIsSpinningPayload {
  return {
    type: LuckySpinActions.SetSpinning,
    payload: {
      isSpinning,
    },
  };
}

export function setLuckySpinPrize(
  prize: Nullable<LuckySpinReward>,
): SetPrizePayload {
  return {
    type: LuckySpinActions.SetPrize,
    payload: {
      prize,
    },
  };
}

export function setLuckySpinIsPrizeDefined(
  isPrizeDefined: boolean,
): SetIsPrizeDefinedPayload {
  return {
    type: LuckySpinActions.SetIsPrizeDefined,
    payload: {
      isPrizeDefined,
    },
  };
}

export function resetLuckySpin(): LuckySpinBasePayload<LuckySpinActions.ResetLuckySpin> {
  return {
    type: LuckySpinActions.ResetLuckySpin,
    payload: null,
  };
}
